import { tv } from 'tailwind-variants';

const componentStyles = tv({
    slots: {
        container: `
      iris:flex
      iris:h-fit
      iris:w-fit
      iris:flex-col
      iris:rounded-(--comp-size-radius-listbox-item)
      iris:bg-(--comp-color-background-listbox)
    `,
        sheet: `
      iris:w-full 
      iris:md:hidden
    `,
        sheetBody: `
      iris:px-(--base-space-px-8)
      iris:py-(--base-space-px-16)
    `,
        popover: `
      iris:hidden
      iris:p-(--comp-space-padding-listbox-popover)
      iris:md:inline-block
    `,
        labelInner: `
      iris:pt-(--comp-space-padding-select-inner-label-filled-top)
      iris:pb-(--comp-space-padding-select-inner-label-filled-bottom)
      iris:text-(length:--comp-type-size-input-value)
      iris:data-[hasvalue=false]:pt-(--comp-space-padding-text-input-vertical)
      iris:data-[hasvalue=false]:pb-(--comp-space-padding-text-input-vertical)
    `,
        group: `
      iris:flex
      iris:h-(--comp-size-height-listbox-item-desktop)
      iris:gap-(--comp-space-gap-listbox-count)
      iris:py-(--comp-space-padding-listbox-item-vertical)
      iris:pr-(--comp-space-padding-listbox-item-horizontal)
      iris:pl-(--comp-space-padding-listbox-option-group-left)
     
      iris:font-(family-name:--comp-type-font-listbox)
      iris:text-(length:--comp-type-size-listbox)
      iris:leading-(--base-type-leading-normal)
      iris:font-(--comp-type-weight-listbox)!
      iris:tracking-(--comp-type-tracking-listbox)
      iris:text-(--comp-color-content-listbox-group)
    `,
        item: `
      iris:align-self-stretch
      iris:flex
      iris:h-(--comp-size-height-listbox-item-desktop)
      iris:w-full
      iris:cursor-pointer
      iris:items-center
      iris:gap-(--comp-space-gap-listbox-icon)
      iris:rounded-(--comp-size-radius-listbox-item)
      iris:px-(--comp-space-padding-listbox-item-horizontal)
      iris:py-(--comp-space-padding-listbox-item-vertical)
      iris:font-(family-name:--comp-type-font-listbox)

      iris:text-(length:--comp-typography-size-listbox)
      iris:leading-(--base-typography-leading-normal)
      iris:font-(--comp-typography-weight-listbox)!
      iris:tracking-(--comp-typography-tracking-listbox)
      iris:transition
      iris:hover:bg-(--comp-color-background-listbox-item-hover)
      iris:focus-visible:ring-2
      
      iris:focus-visible:ring-(--sem-color-border-interactive-selected)
      iris:focus-visible:outline-none
      iris:active:bg-(--comp-color-background-listbox-item-pressed)
      iris:data-[state=disabled]:cursor-not-allowed
      iris:data-[state=disabled]:opacity-(--sem-opacity-interactive-disabled)
      iris:data-[state=disabled]:hover:bg-(--comp-color-background-popover-default)
      
      iris:data-[state=disabled]:active:bg-(--comp-color-background-popover-default)
      iris:data-[state=selected]:pr-(--comp-space-padding-listbox-item-horizontal)
      iris:data-[state=selected]:pl-(--comp-space-padding-listbox-item-selected-left)
      iris:data-[state=selected]:hover:bg-(--comp-color-background-listbox-item-selected-hover)
      iris:data-[state=selected]:active:bg-(--comp-color-background-listbox-item-selected-pressed)

    `,
        labelWrapper: `
      iris:flex
      iris:gap-(--comp-space-gap-listbox-count)
    `,
        label: `
      iris:font-(family-name:--comp-type-font-input-value)
      iris:font-(--comp-type-weight-input-value)!
      iris:data-[state=default]:text-(--comp-color-content-listbox-label)
      iris:data-[state=selected]:text-(--comp-color-content-listbox-label-selected)
    `,
        count: `
      iris:text-(--comp-color-content-listbox-count)
    `,
        iconWrapper: `
      iris:flex
      iris:h-(--comp-size-icon-listbox)
      iris:w-(--comp-size-icon-listbox)
      iris:items-center
    `,
        icon: `
      iris:text-(--comp-color-content-listbox-icon)
    `,
        divider: `
      iris:px-(--comp-space-padding-listbox-divider-horizontal)
      iris:py-(--base-space-px-8)
    `,
    },
    variants: {
        inverse: {
            true: {
                item: `
          iris:md:hover:bg-(--comp-color-background-listbox-item-inverse-hover)
          iris:md:focus-visible:ring-(--sem-color-border-interactive-inverse-selected)
          iris:md:active:bg-(--comp-color-background-listbox-item-inverse-pressed)
          iris:md:data-[state=disabled]:hover:bg-(--comp-color-background-popover-inverse)
          iris:md:data-[state=disabled]:active:bg-(--comp-color-background-popover-inverse)
          iris:md:data-[state=selected]:hover:bg-(--comp-color-background-listbox-item-inverse-hover)      
          iris:md:data-[state=selected]:active:bg-(--comp-color-background-popover-inverse)
        `,
                icon: `
          iris:md:text-(--comp-color-content-listbox-icon-inverse)
        `,
                label: `
          iris:md:data-[state=default]:text-(--comp-color-content-listbox-label-inverse)
          iris:md:data-[state=disabled]:text-(--comp-color-content-listbox-label-inverse)
          iris:md:data-[state=selected]:text-(--comp-color-content-listbox-label-selected-inverse)
        `,
                count: `
          iris:md:text-(--comp-color-content-listbox-count-inverse)
        `,
                group: `
          iris:md:text-(--comp-color-content-listbox-group-inverse)
        `,
            },
        },
        disabled: {
            true: {
                container: `
          iris:cursor-not-allowed
          iris:opacity-(--sem-opacity-interactive-disabled)
        `,
            },
        },
    },
    compoundVariants: [
        {
            inverse: true,
            disabled: true,
            class: {
                container: `
          iris:hover:bg-(--comp-color-background-popover-inverse)
          iris:active:bg-(--comp-color-background-popover-inverse)
        `,
            },
        },
    ],
});

export { componentStyles as default };
